// src/components/admin/TextInput.jsx
const TextInput = (props) => (
  <input
    {...props}
    className={`w-full rounded-2xl border border-gray-200 px-3 py-2 outline-none focus:ring-2 focus:ring-indigo-500 ${props.className || ""}`}
  />
);
export default TextInput;
